import { render, staticRenderFns } from "./GifGrid.vue?vue&type=template&id=6f20821b&scoped=true&"
import script from "./GifGrid.vue?vue&type=script&lang=ts&"
export * from "./GifGrid.vue?vue&type=script&lang=ts&"
import style0 from "./GifGrid.vue?vue&type=style&index=0&id=6f20821b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20821b",
  null
  
)

export default component.exports